<template>
  <Modal
    centered
    :visible="visible"
    :title="null"
    :animated="false"
    :footer="null"
    :body-style="{ width: '800px', height: '600px', padding: 0 }"
    wrap-class-name="notification-modal-wrapper"
    :width="800"
    @change="$emit('change', $event)"
    :destroyOnClose="true"
  >
    <Tabs :active-key="activeTabKey" @change="handleTabChange" class="notification-modal-title-tabs">
      <TabPane :key="notifyType.IM_MSG_RELAY_NTY" :tab="$t('notify.FriendNotifications')">
        <div class="notification-main">
          <div class="notification-content">
            <BuilderList
              :dataSource="notifications"
              :itemSize="80"
              keyField="uKey"
              scrollStyle="height: 486px;"
            >
              <template slot-scope="{ item }">
                <template
                  v-if="item.notifyType === notifyType.IM_MSG_RELAY_NTY"
                >
                  <FriendMeta :meta="item" />
                  <div
                    class="meta-body-content"
                  >
                    <ConfirmBtnGroup
                      v-if="item.actType === inviteStatus.RECEIVE"
                      @confirm="acceptInviteFriend(item)"
                      @cancel="rejectInviteFriend(item)"
                    />
                    <span v-else class="text-grey"
                      >{{computeInviteStatus(item.actType)}}</span
                    >
                  </div>
                </template>
              </template>
            </BuilderList>
          </div>
          <div v-if="notifications.length === 0" class="empty-notify-box">
            <Empty :image="emptyTask" :description="$t('home.NoNotice')" />
          </div>
        </div>
      </TabPane>
      <TabPane :key="notifyType.COC_NTY" :tab="$t('notify.CollaborationNotifications')">
        <div class="notification-main">
          <div class="notification-content">
            <WaterfallList
              :fetchData="handleFetchCocData"
              :itemSize="80"
              :dataSource="cocNotifications"
              :nextVer="nextLoadCocNotifyVer"
              keyField="uKey"
              scrollStyle="height: 486px;"
            >
              <template slot-scope="{ item }">
                <CoopeMeta :meta="item" />
                <div class="meta-extra-content">
                  <template v-if="item.conferenceState !== conferenceState.CANCELED">
                    <Button v-if="canViewDetail(item)" shape="round" @click="gotoCocDetail(item)" type="default">
                      <span class="text-black">{{$t('home.ViewDetails')}}</span>
                    </Button>
                  </template>
                  <span v-else class="text-grey"
                      >{{$t('home.Cancelled')}}</span
                  >
                </div>
              </template>
            </WaterfallList>
          </div>
          <div v-if="cocNotifications.length === 0" class="empty-notify-box">
            <Empty :image="emptyTask" :description="$t('home.NoNotice')" />
          </div>
        </div>
      </TabPane>
      <TabPane :key="notifyType.SYSTEM_NOTICE" :tab="$t('notify.SystemNotifications')">
        <div class="notification-main">
          <div class="notification-content">
            <!-- <BuilderList :dataSource="sysnotices" :itemSize="80" keyField="uKey" scrollStyle="height: 486px;">
              <template slot-scope="{ item }">
                <template v-if="item.notifyType === notifyType.SYSTEM_NOTICE">
                  <SysNoticeMeta :meta="item" />
                </template>
              </template>
            </BuilderList> -->
            <template v-for="(item,idx) in sysnotices">
              <template v-if="item.notifyType === notifyType.SYSTEM_NOTICE">
                <SysNoticeMeta :meta="item" :key="idx" mode="custom" />
              </template>
            </template>
          </div>
          <div v-if="sysnotices.length === 0" class="empty-notify-box">
            <Empty :image="emptyTask" :description="$t('home.NoNotice')" />
          </div>
        </div>
      </TabPane>
     </Tabs>
  </Modal>
</template>
<script>
import { Tabs, Modal, Empty, Button } from 'ant-design-vue'
import { NOTIFY_TYPE, INVITE_STATUS, CONFERENCE_CONFIRM_OPTIONS, CONFERENCE_CONFIRM_STATUS, COC_ERR_CODE, CONFERENCE_STATE, PAGE_NAME, CONFERENCE_ACT_STATUS } from '@/utils/constant'
import {
  BuilderList,
  WaterfallList,
} from '@/components/behavior/infinite-list/index'
import ConfirmBtnGroup from '@/components/business/ops-btn/ConfirmBtnGroup.vue'
import {
  FriendMeta,
  CoopeMeta,
  SysNoticeMeta
} from '@/components/business/media-meta/index.js'
import { mapActions, mapState } from 'vuex'

import emptyTask from '@/assets/empty-notify.svg'

// 消息通知模态框
export default {
  name: 'NotificationModal',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    activeTab: {
      type: Number,
      default(){
        return NOTIFY_TYPE.IM_MSG_RELAY_NTY
      }
    }
  },
  data() {
    return {
      activeTabKey: NOTIFY_TYPE.IM_MSG_RELAY_NTY
    }
  },
  components: {
    Tabs: Tabs,
    TabPane: Tabs.TabPane,
    BuilderList,
    WaterfallList,
    Modal,
    ConfirmBtnGroup,
    CoopeMeta,
    FriendMeta,
    Empty,
    Button,
    SysNoticeMeta
  },
  methods: {
    ...mapActions('inviteFriend', ['acceptInviteFriend', 'rejectInviteFriend']),
    ...mapActions('notification', ['loadCocNotify']),
    ...mapActions('coc', ['confirmCocInvite', 'viewCocDetail', 'syncCocData']),
    /** @type {<T>(index?:number, lastItem?: T) => Promise<{list:T[], finished: boolean}>} */
    async handleFetchCocData(index, lastItem) {
      const limit = 20
      const notifyList = await this.loadCocNotify(limit)
      return notifyList.length < 20
    },
    computeInviteStatus(status) {
      switch (status) {
        case INVITE_STATUS.REJECT:
          return this.$t('home.Refused1')
        case INVITE_STATUS.REJECT_YOU:
          return this.$t('home.Refused')
        case INVITE_STATUS.ACCEPT:
          return this.$t('personSetting.Approved1')
        case INVITE_STATUS.ACCEPT_YOU:
          return this.$t('personSetting.Approved2')
      }
    },
    async acceptJoinCoc({ conferenceId }) {
      await this.confirmCocInvite({
        conferenceId: conferenceId,
        confirmStatus: CONFERENCE_CONFIRM_STATUS.CONFIRMED
      })
    },
    async rejectJoinCoc({ conferenceId }) {
      await this.confirmCocInvite({
        conferenceId: conferenceId,
        confirmStatus: CONFERENCE_CONFIRM_STATUS.REJETCED
      })
    },
    computeConfirmCocStatus(status) {
      return CONFERENCE_CONFIRM_OPTIONS[status] || ''
    },
    handleTabChange(val) {
      this.activeTabKey = val
    },
    async gotoCocDetail(item) {
      const conferenceId = item.conferenceId
      try {
        await this.viewCocDetail(conferenceId)
        this.$emit('change', false)
        this.$router.replace({
          name: PAGE_NAME.Home,
          query: {
            conferenceId
          }
        })
      } catch (err) {
        if (err.code === COC_ERR_CODE.CANCELED) {
          // 协作已取消
          this.syncCocData({
            conferenceId,
            changeData: { conferenceState: CONFERENCE_STATE.CANCELED },
            limit: Infinity
          })
        }
        this.$message.error(err.message)
      }
    },
    canViewDetail(record) {
      return record.actType !== CONFERENCE_ACT_STATUS.REMOVE_MEMBER_NTY
    }
  },
  computed: {
    ...mapState('notification', ['notifications', 'cocNotifications', 'nextLoadCocNotifyVer', 'sysnotices']),
    ...mapState(['userInfo']),
    notifyType() {
      return NOTIFY_TYPE
    },
    inviteStatus() {
      return INVITE_STATUS
    },
    emptyTask() {
      return emptyTask
    },
    conferenceState() {
      return CONFERENCE_STATE
    },
  },
  created(){
    this.activeTabKey = this.activeTab
  }
}
</script>
<style lang="less">
@import url(~@/styles/font.less);
@import url(~@/styles/button.less);
.notification-modal-wrapper {
  & > .ant-modal {
    padding-bottom: 0;
    & > .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border: 1px solid #edeff2;
      overflow: hidden;
    }
  }
}

.notification-modal-title-tabs {
  & {
    display: flex;
    flex-direction: column;
    height: 100%;

    .ant-tabs-bar {
      flex-shrink: 1;
      margin-bottom: 0;
    }

    .ant-tabs-tab {
      .regular-font(18);
      margin: 0 0 0 56px;
      padding: 28px 0 10px 0;
      color: #333333;

      &.ant-tabs-tab-active {
        .medium-font(18);
        color: #236cff;
      }
    }

    .ant-tabs-ink-bar {
      background-color: #236cff;
    }

    .ant-tabs-content {
      flex-grow: 1;
    }
  }

  .notification-main {
    position: relative;
    height: 100%;
    margin-right: 8px;
    margin-left: 8px;
    overflow-y: auto;

    & > .notification-content {
      position: absolute;
      width: 100%;
      padding: 16px 0 32px 48px;

      .sys-meta {
        width: 428px;
        flex-shrink: 0;
      }
    }

    .meta-body-content {
      flex-shrink: 0;
      width: 300px;
      text-align: right;
      padding: 0 24px;
    }

    .meta-extra-content {
      flex-shrink: 0;
      // width: 120px;
      text-align: right;
      // padding: 0 24px;

      & > .ant-btn-default {
        .default-btn-mixins();
      }
    }
  }

  .empty-notify-box {
    position:absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);
    .ant-empty-description {
      color: #999b9f;
    }
  }
}
</style>
